export enum AudienceCategory {
  Basic = 1,
  PreBuilt,
  MasterFile,
  Nls,
}
